import apiClient from "./client";
import { API_ROUTES_RELATIVE } from "@/routes/api";

/**
 * Public-safe feature flags exposed to authenticated customers via GET /api/features.
 * Mirrors the whitelist in server/config/services.php (`public_features`).
 */
export type PublicFeatureFlag = "design_color_scheme" | "design_font_family" | "onboarding_wizard";

export type PublicFeatures = Record<PublicFeatureFlag, boolean>;

/** Everything is OFF until the backend says otherwise (parked features stay hidden). */
export const DEFAULT_PUBLIC_FEATURES: PublicFeatures = {
  design_color_scheme: false,
  design_font_family: false,
  onboarding_wizard: false,
};

interface PublicFeaturesResponse {
  features?: Partial<Record<string, unknown>>;
}

export async function getPublicFeatures(): Promise<PublicFeatures> {
  const { data } = await apiClient.get<PublicFeaturesResponse>(API_ROUTES_RELATIVE.features.list());
  const incoming = data?.features ?? {};

  return {
    design_color_scheme: incoming.design_color_scheme === true,
    design_font_family: incoming.design_font_family === true,
    onboarding_wizard: incoming.onboarding_wizard === true,
  };
}
